import Link from "@insite/mobius/Link";
import { COLORS, ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";
import styled from "styled-components";

export interface StyledLinkProps {
    textColor?: string;
}

// NOTE: All theme interpolations are wrapped in functions so the design proxy
// resolves per render (with request context on server / hostname on client).
// Inline string interpolations would be evaluated at module load time, when
// getUrl() throws on the server and the proxy falls back to suryaDesign -
// causing SSR HTML to bake in Surya fonts/colors for every brand. After
// client-side navigation styled-components re-renders with the correct brand,
// but a hard refresh would revert to the SSR-baked Surya values.
export const StyledLink = styled(Link)<StyledLinkProps>`
    color: ${props => props.textColor || COLORS.text.link};
    text-decoration: none;
    text-transform: uppercase;
    font-family: ${() => TYPOGRAPHY.fontFamily.title};
    font-weight: ${() => TYPOGRAPHY.link.weight};
    font-size: ${() => TYPOGRAPHY.link.size}px;
    cursor: pointer;
    border-bottom: ${() => (TYPOGRAPHY.link as any).borderWidth || "3px"} solid ${props => props.textColor || COLORS.text.link};
    padding-bottom: 4px;
    display: inline-block;
    letter-spacing: ${() => ELEMENTS.button.link.letterSpacing || "normal"};
    
    && span,
    && .StyledTypography {
        color: ${props => props.textColor || COLORS.text.link};
        font-family: ${() => TYPOGRAPHY.fontFamily.title};
        font-weight: ${() => TYPOGRAPHY.link.weight};
        font-size: ${() => TYPOGRAPHY.link.size}px;
        text-transform: uppercase;
        text-decoration: none;
        letter-spacing: ${() => ELEMENTS.button.link.letterSpacing || "normal"} !important;
    }

    span {
        letter-spacing: ${() => ELEMENTS.button.link.letterSpacing || "normal"} !important;
    }
    
    &:hover {
        opacity: 0.8;
        
        && span,
        && .StyledTypography {
            color: ${props => props.textColor || COLORS.text.link} !important;
            opacity: 0.8;
        }
    }
`;

export default StyledLink;